import React from 'react';
import TabHeaderTitle from './tab-header-title/tab-header-title';
import Styles from './tab-header-styles.scss';
const TabHeader = ({ children, icon, title, backButton, backButtonComponent: BackButton }) => {
    return (React.createElement("div", { className: Styles.tabHeaderWrap },
        React.createElement("div", { className: Styles.left },
            backButton && BackButton && BackButton,
            React.createElement(TabHeaderTitle, { icon: icon, title: title })),
        React.createElement("div", { className: Styles.buttons }, children)));
};
export default TabHeader;
